const convertPlate = (plate = '') => {
  const charMap = {
    Α: 'A',
    Β: 'B',
    Ε: 'E',
    Η: 'H',
    Ι: 'I',
    Κ: 'K',
    Μ: 'M',
    Ν: 'N',
    Ο: 'O',
    Ρ: 'P',
    Τ: 'T',
    Χ: 'X',
    Υ: 'Y',
    Ζ: 'Z',
  };

  return (
    plate
      // remove accents
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      // convert to uppercase
      .toUpperCase()
      // remove spaces
      .replace(/\s/g, '')
      // replace Greek characters
      .replace(/[ΑΒΕΗΙΚΜΝΟΡΤΧΥΖ]/g, (char) => charMap[char] || char)
  );
};
export default convertPlate;
